import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-block" }
const _hoisted_2 = { class: "main-lot-image-block" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "main-lot-image" }
const _hoisted_8 = {
  key: 0,
  class: "magnifier-zoom-image"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["data-magnifier-src"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]

import { computed, onMounted, onUnmounted } from "vue";
  import Swiper from "@/components/_partials/Swiper.vue";
  import VideoPlayerCustom from "@/components/_partials/VideoPlayerCustom.vue";
  import CardInfoBlock from "@/components/CardInfoBlock.vue";
  import { LotFileTypes } from "@/enum";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { ILotPopupData } from "@/models";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LotDetailsPopup',
  props: {
    lotProp: {}
  },
  emits: ["closeForm", "changeTitle", "setModalHeightAuto"],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;

  const auctionStore = useAuctionStore();
  const lot = computed(() => auctionStore.popupLot as ILotPopupData);
  const files = computed(() => lot.value?.files);

  const props = __props;

  onMounted(() => {
    auctionStore.$patch((state) => {
      state.popupLot = props.lotProp;
    });
  });

  onUnmounted(() => {
    auctionStore.$patch((state) => {
      state.popupLot = null;
    });
  });

return (_ctx: any,_cache: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (files.value?.length > 1)
        ? (_openBlock(), _createBlock(Swiper, {
            key: 0,
            class: "images-swiper-navigation",
            direction: "vertical",
            "slides-per-view": 'auto',
            navigation: true,
            type: "lotGallery"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                  class: "navigation-image",
                  key: index
                }, {
                  default: _withCtx(() => [
                    (file.type === _unref(LotFileTypes).IMAGE)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: file.src,
                          alt: "lot"
                        }, null, 8, _hoisted_3))
                      : (file.type === _unref(LotFileTypes).PDF)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _unref(auctionStore).filePlaceholders.pdf_min,
                            class: "mini-video-placeholder",
                            alt: "lot"
                          }, null, 8, _hoisted_4))
                        : (file.type === _unref(LotFileTypes).VIDEO)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 2,
                              src: _unref(auctionStore).filePlaceholders.video,
                              class: "mini-video-placeholder",
                              alt: "lot"
                            }, null, 8, _hoisted_5))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 3,
                              src: _unref(auctionStore).filePlaceholders.no_image,
                              alt: "lot"
                            }, null, 8, _hoisted_6))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(Swiper, {
          "thumbs-swiper": ".images-swiper-navigation .swiper-wrapper",
          "slides-per-view": 1,
          navigation: false,
          "allow-touch-move": false,
          type: "lotGalleryMain"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                class: "swiper-slide",
                key: index
              }, {
                default: _withCtx(() => [
                  (file.type === _unref(LotFileTypes).IMAGE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("img", {
                          class: "magnifier-image",
                          src: file.src,
                          alt: "lot"
                        }, null, 8, _hoisted_9),
                        _createElementVNode("div", {
                          class: "magnifier-zone",
                          "data-magnifier-src": file.src
                        }, null, 8, _hoisted_10)
                      ]))
                    : (file.type === _unref(LotFileTypes).PDF)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: file.src,
                          class: "magnifier-zoom-image",
                          target: "_blank"
                        }, [
                          _createElementVNode("img", {
                            src: _unref(auctionStore).filePlaceholders.pdf,
                            alt: "lot",
                            class: "pdf-placeholder"
                          }, null, 8, _hoisted_12)
                        ], 8, _hoisted_11))
                      : (file.type === _unref(LotFileTypes).VIDEO)
                        ? (_openBlock(), _createBlock(VideoPlayerCustom, {
                            key: 2,
                            class: "custom-video-player magnifier-zoom-image",
                            "video-src": file.src,
                            title: "lot"
                          }, null, 8, ["video-src"]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 3,
                            class: "magnifier-image",
                            src: _unref(auctionStore).filePlaceholders.no_image,
                            alt: "lot"
                          }, null, 8, _hoisted_13))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    (lot.value?.id)
      ? (_openBlock(), _createBlock(CardInfoBlock, {
          key: 0,
          onCloseForm: _cache[0] || (_cache[0] = ($event: any) => (emit('closeForm')))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})